// utils/valueToRadioOptions.ts
export const valueToRadioOptions = <
	T extends string,
	F extends (key: T) => string,
>(
	value: T,
	localizeFn?: F,
) => ({
	label: typeof localizeFn === 'function' ? localizeFn(value) : value,
	value,
});

export function generateNumberSteps(start: number, end: number, step: number): number[] {
	const length = Math.floor((end - start) / step) + 1;

	return Array.from({ length }, (_, i) => start + i * step);
}

export type Range = {
	end:   null | number
	start: number
};

export function generateNumberRanges(
	start: number,
	end: number,
	step: number,
): Range[] {
	const ranges: Range[] = [];
	const currentStart = start;
	let currentEnd = start + step - 1;

	ranges.push({ end: currentStart, start: 0 });

	while (currentEnd < end) {
		const nextStart = currentEnd + 1;
		const nextEnd = Math.min(nextStart + step - 1, end);
		ranges.push({ end: nextEnd, start: nextStart });
		currentEnd = nextEnd;
	}

	ranges.push({ end: null, start: end + 1 });

	return ranges;
}

export function renderLabel(range: Range) {
	if (range.end === null) return `${range.start.toLocaleString()} ~`;

	if (range.start === 0) return `~ ${range.end.toLocaleString()}`;

	return `${range.start.toLocaleString()} - ${range.end.toLocaleString()}`;
}
